import { isFeatureEnabledFromConfig } from "./featureFlags";

/** @type {string} Tenant flag for the Dispatch "Build trip" CTA. */
export const DISPATCH_BUILD_TRIP_FEATURE_KEY = "dispatch.buildTrip.enabled";

/**
 * Whether Dispatch may show Build trip and start a Manifest V2 trip draft.
 * Opt-in for every tenant: both this flag and trip manifests must be explicit true.
 * Also used for leg form Shipping & compliance (same two flags).
 *
 * @param {object} [configs]
 * @returns {boolean}
 */
export function isDispatchBuildTripEnabled(configs = {}) {
  return (
    isFeatureEnabledFromConfig(configs, DISPATCH_BUILD_TRIP_FEATURE_KEY) &&
    isFeatureEnabledFromConfig(configs, "manifests.v2.enabled")
  );
}
